import { AppDisplay } from '@ui/applications';
import { AppStatusIndicator } from './AppStatusIndicator';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
export const appColumn = {
    dataIndex: 'applicationId',
    key: 'applicationId',
    render: (applicationId, record) => React.createElement("a", { href: record.statusPageUrl, target: '_blank' },
        React.createElement(AppDisplay, { appId: applicationId, appLabel: record.applicationLabel, appName: record.applicationName })),
    title: COPY_SPECIFIC.APPLICATION,
    width: 170
};
export const statusColumn = (sorter = false) => ({
    dataIndex: 'status',
    key: 'status',
    render: (status) => React.createElement(AppStatusIndicator, { statusType: status }),
    sorter,
    title: COPY_SPECIFIC.STATUS,
    width: 125
});
export function getColumns(showSort) {
    return [
        appColumn,
        { key: 'spacer' },
        statusColumn(showSort)
    ];
}
